import { carEquityManageApi } from '@api/api'
export default {
  data() {
    return {

      carTableData: [],
      carTableParams: {
        tableOption: true,
        rowClassName: ({ row, rowIndex }) => {
          return row.status == 0 ? 'opacity' : ''
        },
        tableColumns: [{
            label: '权益名称',
            prop: 'equityName',
            minWidth: '200',
          },
          {
            label: '权益描述',
            prop: 'equityDesc',
            minWidth: '200',
          },
          {
            label: '权益图标\n（80*80，支持JPG、PNG、GIF',
            minWidth: '200',
            formatter: (cell) => {
              return `<img class="equity-icon" src="${cell.equityIcon}" />`
            }
          },
          {
            label: '服务提供方',
            minWidth: '200',
            formatter: (cell) => {
              return {
                GL_OIL: '广联-加油',
                GL_ROAD_RESCUE: '广联-道路救援',
                GL_TIRE_PROTECTION: '广联-轮胎保障',
                GL_ROBBERY_PROTECTION: '广联-盗抢无忧',
                GL_COLLISION_REPAIR: '广联-碰撞维修',
                GL_CAR_TOTAL_LOSS: '广联-整车全损',
                EDJ: 'e代驾'
              }[cell.supplier]
            }
          },
        ]
      },

    }
  },
  mounted() {


  },
  methods: {

    /**汽车权益列表 */
    getCarList() {
      carEquityManageApi.getCarList().then(({ data }) => {
        this.carTableData = data.list || []
      })
    },

  }
}